import React from "react";
import { RegisteredCounterpartyIncludeScope } from "@common/helpers/counterparties";
import { useCounterpartiesQuery } from "@api/counterparty.api";
import { CounterpartiesFilterLabel } from "./CounterpartiesFilterLabel";

type CounterpartiesFilterLabelProps = React.ComponentProps<
    typeof CounterpartiesFilterLabel
>;

export const CounterpartiesNamedFilterLabel: React.FC<
    Omit<CounterpartiesFilterLabelProps, "counterparties">
> = ({ filters, entityLabel }) => {
    const selectedIds = filters.counterpartiesIds ?? [];
    const counterparties = useCounterpartiesQuery(
        {
            counterpartiesIds: selectedIds,
            includeRegistered: RegisteredCounterpartyIncludeScope.ALL,
        },
        { enabled: selectedIds.length === 1 },
    );

    return (
        <CounterpartiesFilterLabel
            filters={filters}
            counterparties={counterparties.data?.data}
            entityLabel={entityLabel}
        />
    );
};
